import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  userAgent:any="";
  ngOnInit() {
    let browserDetail=this.detectBrowserVersion();
    localStorage.setItem('browserDetail',browserDetail);
  //  console.log(browserDetail)
  }

  // getBrowserInfo(){
  //      const agent = window.navigator.userAgent.toLowerCase();
  //   const browser =
  //     agent.indexOf('edge') > -1 ? 'Microsoft Edge'
  //       : agent.indexOf('edg') > -1 ? 'Chromium-based Edge'
  //       : agent.indexOf('opr') > -1 ? 'Opera'
  //       : agent.indexOf('chrome') > -1 ? 'Chrome'
  //       : agent.indexOf('trident') > -1 ? 'Internet Explorer'
  //       : agent.indexOf('firefox') > -1 ? 'Firefox'
  //       : agent.indexOf('safari') > -1 ? 'Safari'
  //       : 'other';

  //   return browser;
   
  // }
  detectBrowserVersion(){
    var userAgent = navigator.userAgent, tem, 
    matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    
    if(/trident/i.test(matchTest[1])){
        tem =  /\brv[ :]+(\d+)/g.exec(userAgent) || [];
        return 'IE '+(tem[1] || '');
    }
    if(matchTest[1]=== 'Chrome'){
        tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    matchTest= matchTest[2]? [matchTest[1], matchTest[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem= userAgent.match(/version\/(\d+)/i))!= null) matchTest.splice(1, 1, tem[1]);
    return matchTest.join(' ');
}
}
